import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UITooltip from '../tooltip/UITooltip';
import UIIcon from './UIIcon';
import { EERIE, OLAF } from 'HubStyleTokens/colors';
import passthroughProps from '../utils/propTypes/passthroughProps';
const USE_DARK = 'on-dark';
const USE_DEFAULT = 'default';
export default function UIHelpIcon(props) {
  const {
    use,
    tooltipPlacement,
    tooltipProps,
    title,
    className,
    style,
    children
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["use", "tooltipPlacement", "tooltipProps", "title", "className", "style", "children"]);

  const iconColor = use === USE_DARK ? OLAF : EERIE;
  const classes = classNames('private-help-icon', className, children && 'private-help-icon--inline');
  const computedTooltipPlacement = !tooltipPlacement && tooltipProps && tooltipProps.placement ? tooltipProps.placement : tooltipPlacement;
  return /*#__PURE__*/_jsxs("span", {
    className: classes,
    style: style,
    children: [children, /*#__PURE__*/_jsx(UITooltip, Object.assign({}, tooltipProps, {
      placement: computedTooltipPlacement,
      title: title,
      children: /*#__PURE__*/_jsx(UIIcon, Object.assign({
        className: "private-help-icon__icon",
        name: "info",
        color: iconColor
      }, rest))
    }))]
  });
}
UIHelpIcon.defaultProps = {
  use: USE_DEFAULT
};
UIHelpIcon.propTypes = {
  size: UIIcon.propTypes.size,
  color: UIIcon.propTypes.color,
  use: PropTypes.oneOf([USE_DARK, USE_DEFAULT]),
  tooltipPlacement: UITooltip.propTypes.placement,
  tooltipProps: passthroughProps(UITooltip),
  title: PropTypes.node.isRequired,
  children: PropTypes.node
};
UIHelpIcon.displayName = 'UIHelpIcon';